module.exports = function() {
  return new Worker(__webpack_public_path__ + "c78cc0dd1ca7d801a6d9.worker.js");
};